import React from 'react';
import Icon from '../../../components/AppIcon';
import FreeAccessNotice from '../../../components/FreeAccessNotice';
import SiteMessageContainer from '../../../components/SiteMessageContainer';

const SubscriptionPreview = () => {
  const features = [
    {
      icon: 'Gamepad2',
      title: 'Unlimited Game Access',
      description: 'Play any game in our library'
    },
    {
      icon: 'Ban',
      title: 'Ad-Free Experience',
      description: 'No ads anywhere on the site'
    },
    {
      icon: 'Zap',
      title: 'Instant WebGPU Streaming',
      description: 'No downloads or installations'
    },
    {
      icon: 'Users',
      title: 'Community Features',
      description: 'Connect with other gamers'
    },
    {
      icon: 'Trophy',
      title: 'Achievement System',
      description: 'Track your gaming progress'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-6 space-y-6">
      {/* Site Messages */}
      <SiteMessageContainer page="subscription_preview" variant="compact" />

      {/* Free Access Notice */}
      <FreeAccessNotice variant="compact" />

      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
          <Icon name="Crown" size={32} className="text-primary" />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-2">All Access Premium</h3>
        <div className="flex items-center justify-center space-x-2">
          <span className="text-3xl font-bold text-primary">$5</span>
          <span className="text-muted-foreground">/month</span>
        </div>
        <div className="bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 px-3 py-1 rounded-full text-sm font-medium mt-2 inline-block">
          7 days free trial
        </div>
        <p className="text-sm text-muted-foreground mt-2">Cancel anytime • No commitments</p>
      </div>

      <div className="space-y-4">
        <h4 className="font-semibold text-foreground text-center">What's included:</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={feature.icon} size={16} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{feature.title}</p>
                <p className="text-xs text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Gift" size={16} className="text-green-600 dark:text-green-400" />
          <span className="text-sm font-medium text-green-800 dark:text-green-200">Free Trial</span>
        </div>
        <p className="text-sm text-green-700 dark:text-green-300">
          Start with 7 days completely free! No charges until your trial ends.
          <span className="text-green-800 dark:text-green-200 font-medium"> Cancel anytime.</span>
        </p>
      </div>

      <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
        <div className="flex items-center space-x-1">
          <Icon name="Shield" size={12} />
          <span>Secure Payment</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Lock" size={12} />
          <span>SSL Encrypted</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="CreditCard" size={12} />
          <span>Stripe Protected</span>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPreview;
